<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:20px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    <Divider />
    <Row>
      <Col span="24">
        <v-table
          :title="this.report_set_up_record_title"
          :title_info="this.report_set_up_record_info"
          :table_columns="this.report_set_up_record_table_columns"
          :table_data="this.report_set_up_record_table_data"
          :table_ref="this.report_set_up_record_ref"
          :max_height="750"
          :table_page_size="100"
          :show_top="false"
          :show_page="false"
          :init_table="this.report_set_up_record_init_table_func"
          :table_name_array="this.report_set_up_name_array"
        ></v-table>
      </Col>
    </Row>
    <Modal
      v-model="confirme_delete_model"
      title="即将清空发送日期记录"
      :loading="true"
      @on-ok="confirme_delete_ok"
      @on-cancel="confirme_delete_cancel"
    >
      <p>选中的账户ID为:{{ confirme_delete_id }}</p>
    </Modal>
  </div>
</template>


<script>
import table_view from "../components/TableView.vue";
import qs from "qs";
export default {
  name: "run_report_set_up",
  components: {
    "v-table": table_view
  },
  data() {
    return {
      table_title: "实盘运行报告设置页面",
      confirme_delete_model: false,
      confirme_delete_id: null,
      confirme_delete_index: null,
      // 管理按钮的状态
      report_set_up_record_button_loading_status: [],
      report_set_up_record_button_disable_status: [],
      report_set_up_record_title: "",
      report_set_up_record_info: [],
      report_set_up_record_table_columns: [],
      report_set_up_record_table_data: [],
      report_set_up_record_ref: "report_set_up_record_ref",
      report_set_up_name_array: [
        "账户编号",
        "账户名",
        "本位",
        "展示项选择",
        "账户说明",
        "邮箱",
        "最近日报发送日期",
        "功能",
        "发送选项"
      ]
    };
  },
  computed: {},
  watch: {
    report_set_up_record_button_disable_status: {
      handler: function() {
        for (
          var i = 0;
          i < this.report_set_up_record_button_disable_status.length;
          i++
        ) {
          this.set_able(i, this.report_set_up_record_button_disable_status[i]);
        }
      },
      deep: true
    },
    report_set_up_record_button_loading_status: {
      handler: function() {
        for (
          var i = 0;
          i < this.report_set_up_record_button_loading_status.length;
          i++
        ) {
          this.set_loading(
            i,
            this.report_set_up_record_button_loading_status[i]
          );
        }
      },
      deep: true
    },
    report_set_up_record_table_data: {
      handler: function() {
        // for (var i = 0; i < this.report_set_up_record_table_data.length; i++) {
        //   this.set_loading(i, this.report_set_up_record_button_loading_status[i]);
        //   this.set_able(i, this.report_set_up_record_button_disable_status[i]);
        //   this.set_show_which_line(i, this.report_set_up_record_table_data[i][3])
        // }
      },
      deep: true
    }
  },
  methods: {
    confirme_delete_init: function() {
      this.confirme_delete_id = null;
      this.confirme_delete_index = null;
    },
    confirme_delete_ok: function() {
      this.send_clear_request(this.confirme_delete_id);
      setTimeout(() => {
        this.confirme_delete_model = false;
        this.confirme_delete_init();
      }, 500);
    },
    confirme_delete_cancel: function() {
      this.confirme_delete_init();
    },
    get_account_msg: async function() {
      const formData = new FormData();
      formData.append("data", null);
      formData.append("account_id", null);
      formData.append("mode", "get_account_msg");
      let data = await this.$axios({
        url: this.$store.state.urlPort + "/strategy_report",
        method: "post",
        data: formData
      });
      this.set_report_set_up_name_data(data);
    },
    send_clear_request: async function(account_id) {
      // 发送清空日期请求
      const formData = new FormData();
      formData.append("data", JSON.stringify({ last_report_datetime: "" }));
      formData.append("account_id", account_id);
      formData.append("mode", "change_account_report_status");
      let data = await this.$axios({
        url: this.$store.state.urlPort + "/strategy_report",
        method: "post",
        data: formData
      });
      if (data["status"] == true) {
        this.$Message.success({ content: data["data"], duration: 5 });
        this.get_account_msg();
      } else {
        this.$Message.error({ content: data["data"], duration: 5 });
      }
    },
    send_report_request: async function(index, account_id) {
      // 发送日报请求
      const formData = new FormData();
      formData.append("data", "");
      formData.append("account_id", account_id);
      formData.append("mode", "report");
      let data = await this.$axios({
        url: this.$store.state.urlPort + "/strategy_report",
        method: "post",
        data: formData
      });
      if (data["status"] == true) {
        this.$Message.success({ content: data["data"], duration: 5 });
      } else {
        this.$Message.error({ content: data["data"], duration: 5 });
      }
      setTimeout(() => {
        this.$set(
          this.report_set_up_record_button_loading_status,
          index,
          false
        );
        this.get_account_msg();
      }, 1000);
    },
    set_loading: function(index, status) {
      this.$refs.set_up_report_button[index].loading = status;
    },
    set_able: function(index, status) {
      if ("set_up_report_button" in this.$refs == false) {
        return null;
      }
      Number(status) == 0 ? (status = false) : (status = status);
      Number(status) == 1 ? (status = true) : (status = status);
      this.$refs.set_up_report_button[index].disabled = status;
    },
    set_show_which_line: function(index, value) {
      if ("set_up_report_line" in this.$refs == false) {
        return null;
      }
      let color_list = [];
      for (var i = 0; i < 3; i++) {
        this.$refs.set_up_report_line[index][i].color = i == value?"#2b85e4":"#c5c8ce";
      }
    },
    set_report_set_up_name_data: function(data) {
      var report_set_up_record_button_disable_status = [];
      // 多加了一列功能选项，前端补充
      for (var i = 0; i < data["data"].length; i++) {
        data["data"][i].splice(7, 0, "");
        report_set_up_record_button_disable_status.push(data["data"][i][8]);
      }
      this.report_set_up_record_button_disable_status = report_set_up_record_button_disable_status;
      this.report_set_up_record_table_data = data["data"];
    },
    report_set_up_record_init_table_func: function() {
      const name_array = this.report_set_up_name_array;
      this.report_set_up_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.report_set_up_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.report_set_up_record_table_columns[0]["minWidth"] = 85;
      this.report_set_up_record_table_columns[1]["minWidth"] = 150;
      this.report_set_up_record_table_columns[1]["tooltip"] = true;
      this.report_set_up_record_table_columns[2]["minWidth"] = 85;
      this.report_set_up_record_table_columns[2]["render"] = (h, params) => {
        var value = Number(params["row"]["本位"]) == 0 ? "BTC本位" : "USDT本位";
        return h("div", [
          h(
            "span",
            {
              props: {},
              style: {
                marginRight: "5px",
                color:
                  Number(params["row"]["本位"]) == 0 ? "#893448" : "#eb8146"
              }
            },
            value
          )
        ]);
      };
      this.report_set_up_record_table_columns[3]["minWidth"] = 150;
      this.report_set_up_record_table_columns[3]["render"] = (h, params) => {
        let change_show_witch_line = async (account_id, value) => {
          const formData = new FormData();
          formData.append(
            "data", JSON.stringify({ show_which_line: value })
          );
          formData.append("account_id", account_id);
          formData.append("mode", "change_account_report_status");
          let data = await this.$axios({
            url: this.$store.state.urlPort + "/strategy_report",
            method: "post",
            data: formData
          })
        }
        
        // 0 资金量 1.净值 2.百分比
        let index_list = [
          { id: 0, name: "资金量" },
          { id: 1, name: "净值" },
          { id: 2, name: "百分比" }
        ];
        var account_id = params["row"]["账户编号"];
        var index = Number(params["row"]["展示项选择"]);
        if (index == 0) {
          var value = "资金量";
        } else if (index == 1) {
          var value = "净值";
        } else {
          var value = "百分比";
        }
        return h("div", [
          h("span", {
            style: {
              color:value == "资金量"?"#2b85e4":"#c5c8ce",
              cursor:"pointer"
            },
            on: {
                click: () => {
                  this.$set(this.report_set_up_record_table_data[params["index"]], 3, 0)
                  change_show_witch_line(account_id, 0)
                }
            },
            ref: "set_up_report_line",
            // 如果你在渲染函数中给多个元素都应用了相同的 ref 名，
            // 那么 `$refs.myRef` 会变成一个数组。
            refInFor: true
          }, "资金量   "),
          h("span", {
            style: {
              color:value == "净值"?"#2b85e4":"#c5c8ce",
              cursor:"pointer"
            },
            on: {
                click: () => {
                  this.$set(this.report_set_up_record_table_data[params["index"]], 3, 1)
                  change_show_witch_line(account_id, 1)
                }
            }
          }, "净值   "),
          h("span", {
            style: {
              color:value == "百分比"?"#2b85e4":"#c5c8ce",
              cursor:"pointer"
            },
            on: {
                click: () => {
                  this.$set(this.report_set_up_record_table_data[params["index"]], 3, 2)
                  change_show_witch_line(account_id, 2)
                }
            }
          }, "百分比")
        ])
      };
      this.report_set_up_record_table_columns[4]["minWidth"] = 150;
      this.report_set_up_record_table_columns[4]["tooltip"] = true;
      this.report_set_up_record_table_columns[5]["minWidth"] = 150;
      this.report_set_up_record_table_columns[5]["tooltip"] = true;

      this.report_set_up_record_table_columns[6]["width"] = 150;
      this.report_set_up_record_table_columns[6]["tooltip"] = true;
      
      this.report_set_up_record_table_columns[7]["width"] = 180;
      this.report_set_up_record_table_columns[7]["render"] = (h, params) => {
        var account_id = params["row"]["账户编号"];
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
                disabled:this.report_set_up_record_table_data[params["index"]][8] =="1"? false: true
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var index = params["index"];
                  this.$set(
                    this.report_set_up_record_button_loading_status,
                    index,
                    true
                  );
                  this.send_report_request(index, account_id);
                }
              },
              ref: "set_up_report_button",
              // 如果你在渲染函数中给多个元素都应用了相同的 ref 名，
              // 那么 `$refs.myRef` 会变成一个数组。
              refInFor: true
            },
            "发送"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  this.confirme_delete_id = account_id;
                  this.confirme_delete_index = params["index"];
                  this.confirme_delete_model = true;
                }
              }
            },
            "清空"
          )
        ]);
      };

      this.report_set_up_record_table_columns[8]["width"] = 180;
      this.report_set_up_record_table_columns[8]["render"] = (h, params) => {
        var account_id = params["row"]["账户编号"];
        return h("div", [
          this.$createElement("i-switch", {
            props: {
              size: "large",
              "true-color": "#13ce66",
              loading: false,
              value:
                this.report_set_up_record_table_data[params["index"]][8] == "1"? true: false
            },
            style: {
              marginRight: "5px"
            },
            scopedSlots: {
              open: () => h("span", "开启"),
              close: () => h("span", "关闭")
            },
            on: {
              "on-change": async status => {
                this.$set(
                  this.report_set_up_record_table_data[params["index"]], 8, status);
                const formData = new FormData();
                formData.append(
                  "data",
                  JSON.stringify({ report_or_not: status == false ? 0 : 1 })
                );
                formData.append("account_id", account_id);
                formData.append("mode", "change_account_report_status");
                let data = await this.$axios({
                  url: this.$store.state.urlPort + "/strategy_report",
                  method: "post",
                  data: formData
                });
              }
            },
            ref: "set_up_report_switch",
            // 如果你在渲染函数中给多个元素都应用了相同的 ref 名，
            // 那么 `$refs.myRef` 会变成一个数组。
            refInFor: true
          })
        ]);
      };
    }
  },
  mounted() {
    this.get_account_msg();
  },
  created: function() {},
  destroyed() {}
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
</style>